import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-header mb-0" }, "Ajuda")
], -1)
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = {
  class: "accordion",
  id: "accordionFAQ"
}
const _hoisted_5 = ["id"]
const _hoisted_6 = ["data-bs-target", "aria-controls"]
const _hoisted_7 = ["id", "aria-labelledby"]
const _hoisted_8 = { class: "accordion-body text-paragraph" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"card\"><div class=\"card-header\"><p class=\"text-header mb-0\">Entre em contato</p></div><div class=\"card-body\"><p class=\"text-paragraph\"> Caso você precisa de ajuda com o aplicativo, estaremos a disposição para te ajudar no email abaixo: </p><a href=\"mailto:contato@psiapp.com\" class=\"text-subtitle text-secondary\">contato@psiapp.com</a></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faq, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "accordion-item"
            }, [
              _createElementVNode("h2", {
                class: "accordion-header",
                id: `heading${index}`
              }, [
                _createElementVNode("button", {
                  class: _normalizeClass(["accordion-button text-subtitle", { collapsed: index !== 0 }]),
                  type: "button",
                  "data-bs-toggle": "collapse",
                  "data-bs-target": `#collapse${index}`,
                  "aria-expanded": "true",
                  "aria-controls": `collapse${index}`
                }, _toDisplayString(item.question), 11, _hoisted_6)
              ], 8, _hoisted_5),
              _createElementVNode("div", {
                id: `collapse${index}`,
                class: _normalizeClass(["accordion-collapse collapse", { show: index === 0 }]),
                "data-bs-parent": "#accordionFAQ",
                "aria-labelledby": `heading${index}`
              }, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(item.answer), 1)
              ], 10, _hoisted_7)
            ]))
          }), 128))
        ])
      ])
    ]),
    _hoisted_9
  ], 64))
}